import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './ChangePasswordModal.module.css';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://wsticket.frozentoasty.de/api';

function ChangePasswordModal({ isOpen, onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const resetForm = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setError('');
    setSuccess('');
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('Alle Felder sind erforderlich');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Die neuen Passwörter stimmen nicht überein');
      return;
    }

    if (newPassword.length < 6) {
      setError('Das neue Passwort muss mindestens 6 Zeichen lang sein');
      return;
    }

    if (newPassword === currentPassword) {
      setError('Das neue Passwort muss sich vom aktuellen Passwort unterscheiden');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await axios.put(`${API_URL}/auth/change-password`, {
        currentPassword,
        newPassword
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      setSuccess('Passwort erfolgreich geändert');
      setTimeout(() => {
        handleClose();
      }, 2000);

    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Ändern des Passworts');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>Passwort ändern</h2>
          <button className={styles.closeButton} onClick={handleClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label>Aktuelles Passwort:</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Aktuelles Passwort eingeben"
              required
              autoComplete="current-password"
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Neues Passwort:</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Neues Passwort eingeben"
              required
              minLength="6"
              autoComplete="new-password"
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Neues Passwort bestätigen:</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Neues Passwort wiederholen"
              required
              minLength="6"
              autoComplete="new-password"
            />
          </div>

          {error && <div className={styles.error}>{error}</div>}
          {success && <div className={styles.success}>{success}</div>}

          <div className={styles.footer}>
            <button 
              type="button"
              className={styles.cancelButton} 
              onClick={handleClose}
              disabled={loading}
            >
              Abbrechen
            </button>
            <button 
              type="submit"
              className={styles.saveButton}
              disabled={loading}
            >
              {loading ? 'Wird geändert...' : 'Passwort ändern'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}

export default ChangePasswordModal;